import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA  } from '@angular/material';
import { DoctorService } from '../../services/doctor.service';

@Component({
  selector: 'app-documentviewer',
  templateUrl: './documentviewer.component.html',
  styleUrls: ['./documentviewer.component.css']
})
export class DocumentviewerComponent implements OnInit {
  pid: any;
  petdocument: any;
  p = 1;
  constructor(public DialogRef: MatDialogRef<DocumentviewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private doctorService: DoctorService) {
      this.pid = data.pid;
    }

  ngOnInit() {
    this.doctorService.getUploadDocument(this.pid)
    .subscribe(
      (x) => {
      this.petdocument = x;
      });
  }
  getFileExtension(fname) {
    return fname.slice((fname.lastIndexOf(".") - 1 >>> 0) + 2);
  }

}
